export const SkillsArr = [
  "Backend Engineering",
  "API Development",
  "System Design",
  "DDD Architecture",
  "Database Optimization",
  "Performance Optimization",
];

export const HighlightedSkills = [
  "Symfony",
  "PHP",
  "Laravel",
  "Database Optimization",
  "DDD Architecture",
  "System Design",
  "API Development",
  "MySQL",
  "GIT",
  "Eloquent ORM",
  "Doctrine ORM",
];

export const DevOpsExpertiseArr = [["GIT", "Docker", "CI/CD"]];

export const BackendExpertiseArr = [
  ["PHP", "Laravel", "Symfony"],
  ["Python", "FastAPI", "Docker"],
];

export const FrontendExpertiseArr = [
  ["React.js", "Next.js", "Javascript"],
  ["HTML5", "CSS3", "jQuery"],
];

export const DBExpertiseArr = [["MySQL", "MariaDB"]];

export const ArchitectExpertiseArr = [
  ["API Development", "DDD Architecture", "System Design"],
  ["Database Optimization", "Design Patterns"],
];

export const ORMExpertiseArr = [["Eloquent ORM", "Doctrine ORM", "SQlAlchemy"]];
